import { AUTHENTICATED, AUTHENTICATING, AUTHENTICATION_ERROR } from '../action-types/auth';

export const authenticate = (token, code) => {

  return async dispatch => {
    try {
      dispatch({
        type: AUTHENTICATING
      })
     
      const response = await fetch(`${process.env.REACT_APP_API_HOST}${process.env.REACT_APP_API_AUTH_URL}?token=${token}&customer-code=${encodeURIComponent(code)}`,
      {
        method: 'GET',
        headers: {         
          Authorization: `${process.env.REACT_APP_API_TOKEN}`
        }})
      const data = await response.json();
      if (data && data.code) {
        localStorage.setItem('token', token);
        localStorage.setItem('code', data.code);
        dispatch({type: AUTHENTICATED, payload: data})
      } else {
        dispatch({type: AUTHENTICATION_ERROR, payload: data.message})
      }
    } catch(error) {
      dispatch({type: AUTHENTICATION_ERROR, payload: 'Server unreachable, Please contact customer support'})
    }
  }
}


// WEBPACK FOOTER //
// ./src/actions/auth.js